import { Container } from "@mui/material";
import React, { useEffect, useState } from "react";
import Logo from "../assets/images/logo.png";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

const Navbar = () => {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleMobileMenu = () => setIsMenuOpen(!isMenuOpen);
  // 👇 Automatically close mobile menu on route change
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  return (
    <header className="header header-inner">
      <Container>
        <div className="header-wrap">
          <div className="left-content">
            <Link to={""} className="logo">
              <img src={Logo} alt="" />
            </Link>
          </div>
          <div className={`right-menu ${isMenuOpen ? "menu-open" : ""}`}>
            <div className="menu">
              <ul>
                <li>
                  <Link to={"/sustainability"}>Sustainability</Link>
                </li>
                <li>
                  <Link to={"/faqs"}>FAQs</Link>
                </li>
                {/* <li>
                  <Link to={""}>Contact Us</Link>
                </li> */}
                <li className="raise-enquiry">
                  <Link
                    to={"/raise-an-enquiry"}
                    className="text-orange font-bold"
                  >
                    Raise an Enquiry
                    <FontAwesomeIcon icon={faArrowRight} />
                  </Link>
                </li>
              </ul>
              <div className="header-cta">
                <Link className="btn icon-btn" to={"/raise-an-enquiry"}>
                  Raise an Enquiry <FontAwesomeIcon icon={faArrowRight} />
                </Link>
              </div>
            </div>
            <div className="mobile-menu-toggle">
              <div className="hamburger-icon" onClick={handleMobileMenu}>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </header>
  );
};

export default Navbar;
